import Page from "./Page";
import "./Contacts.css";

export const CONTACTS = "Contacts";

// "string".split( "" ).map( c => c.charCodeAt(0) ).map( c => String.fromCharCode( c ) ).join( "" )
const reconstitute = a => a.map( c => String.fromCharCode( c ) ).join( "" );
const MAIL = reconstitute( [ 116, 104, 119, 97, 114, 116, 64, 105, 110, 51, 115, 46, 99, 111, 109 ] ); // HARD-CODED
//const SINGAPORE = reconstitute( [ 43, 54, 53, 46, 54, 53, 51, 46, 49, 53, 57, 46, 49, 52, 57, 51 ] ); // HARD-CODED diamondcard.us
const SPAIN = reconstitute( [ 43, 51, 52, 46, 54, 55, 50, 46, 53, 54, 55, 46, 56, 56, 50 ] ); // HARD-CODED
const US = reconstitute( [ 43, 49, 46, 57, 49, 55, 46, 51, 57, 50, 46, 55, 51, 48, 53 ] ); // HARD-CODED


export default class Contacts extends Page {
   static clicked = false;


   constructor( props ) {
      super( props );

      this.state = { clicked: Contacts.clicked };

      this.onClick = this.onClick.bind( this );
   }


   onClick( e ) {
      if ( !this.state.clicked ) {
         this.setState( { clicked: Contacts.clicked = true } );

         e.preventDefault();
      }
   }


   render() {
      const clicked = Contacts.clicked;
      const reveal = "Reveal";
      const mail = clicked ? MAIL : reveal;
      const americas = clicked ? US : reveal;
      const europe = clicked ? SPAIN : reveal;
      //const asia = clicked ? SINGAPORE : reveal;
      const styleAddress = {
         fontSize: "10pt",
         whiteSpace: "nowrap",
      };

      return (
         <div className="centered">
            <div className="Contacts" onClick={this.onClick}>
               <p><span className="Contacts-right">Mail:</span> <span className="Contacts-left"><a href={`mailto:${mail}`} target="_blank">{mail}</a></span></p>
               <p><span className="Contacts-right">Americas:</span> <span className="Contacts-left"><a href={`tel:${americas}`} target="_blank">{americas}</a></span></p>
               <p><span className="Contacts-right">Europe:</span> <span className="Contacts-left"><a href={`tel:${europe}`} target="_blank">{europe}</a></span></p>
               {
               //<p><span className="Contacts-right">Asia:</span> <span className="Contacts-left"><a href={`tel:${asia}`} target="_blank">{asia}</a></span></p>
               }
               <p style={styleAddress}>
                  Induction Internet Infrastructure Services<br />
                  Canada / Spain / Thailand<br />
               </p>
            </div>
         </div>
      );
   }
}



// WEBPACK FOOTER //
// ./src/Contacts.js